import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { IPaginatedResponse } from "../models/api/paginated-response";
import { IPaginationSearchParams } from "../models/api/pagination-search-params";
import { ICoverPage } from "../models/cover-page/cover-page";
import { ICoverPageSearchParams } from "../models/cover-page/cover-page-search-params";
import { IUpdateCoverPageSearchParams } from "../models/cover-page/update-cover-page-search-params";

@Injectable({ providedIn: "root" })
export class CoverPageService {
  constructor(private readonly _httpClient: HttpClient) {}

  create(payload: ICoverPage) {
    return this._httpClient.post<void>(this.withBaseUrl(), payload);
  }

  getAll(params: IPaginationSearchParams) {
    return this._httpClient.get<IPaginatedResponse<ICoverPage>>(this.withBaseUrl("/all"), { params });
  }

  getOne(params: ICoverPageSearchParams) {
    return this._httpClient.get<ICoverPage>(this.withBaseUrl(), { params });
  }

  update(params: IUpdateCoverPageSearchParams, payload: Partial<ICoverPage>) {
    return this._httpClient.put<void>(this.withBaseUrl(), payload, { params });
  }

  delete(params: ICoverPageSearchParams) {
    return this._httpClient.delete<void>(this.withBaseUrl(), { params });
  }

  private withBaseUrl(endpoint = "") {
    return `${environment.serverUrl}/coverpage${endpoint}`;
  }
}
